import styled from 'styled-components/macro';
export const PaymentHolidayInformationWrapper = styled.div`
  width: 100%;
  .boxLeft {
  }
`;
